import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router";
import App from "../../App";
export default function Wrapper() {
  const [login, setLogin] = useState(false);
  const { ukey } = useParams();

  useEffect(() => {
    if (!login) {
      fetch(
        `https://www.energymarketprice.com/hedgesnew/server/api/ValidateUserKey/${ukey}`
      )
        .then((r) =>
          r.status === 200 ? r.json() : (window.location.href = "/client")
        )
        .then((data) => {
          data.token && sessionStorage.setItem("ukey", ukey);
          data.token && setLogin(true);
        });
    }
  }, [login]);
  return login && <App />;
}
